const nullCheck = (str) => {
  return str == null ? '' : str
}

export {nullCheck}
